import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [blogEnabled, setBlogEnabled] = React.useState(false);

  React.useEffect(() => {
    fetch('/api/home-content')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBlogEnabled(data.content?.settings?.blogEnabled || false);
        }
      })
      .catch(err => console.error('Error fetching settings:', err));
  }, []);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* About Section */}
          <div className="footer-section">
            <h3>Sara M. White</h3>
            <p>{t('footer.aboutText')}</p>
            <div className="social-links">
              <a href="https://instagram.com/tarot_sara_white" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                📷
              </a>
              <a href="https://www.facebook.com/people/Tarot-Sara-White/61553798792674/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                📘
              </a>
              <a href="mailto:tarot@saramwhite.com" aria-label="Email">
                ✉️
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>{t('footer.quickLinks')}</h3>
            <ul className="footer-links">
              <li><Link to="/">{t('nav.home')}</Link></li>
              <li><Link to="/services">{t('nav.services')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
              {blogEnabled && <li><Link to="/blog">{t('nav.blog')}</Link></li>}
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3>{t('footer.contact')}</h3>
            <p>
              <strong>{t('footer.email')}:</strong><br />
              <a href="mailto:tarot@saramwhite.com">tarot@saramwhite.com</a>
            </p>
            <p>
              <strong>{t('footer.location')}:</strong><br />
              Lisboa, Portugal
            </p>
            <p>
              <strong>Instagram:</strong><br />
              <a href="https://instagram.com/tarot_sara_white" target="_blank" rel="noopener noreferrer">
                @tarot_sara_white
              </a>
            </p>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p>&copy; {currentYear} Sara M. White. {t('footer.rights')}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
